import { jsx as _jsx } from "react/jsx-runtime";
const Timer = (props) => {
    return (_jsx("div", { className: "sudoku-controls__timer", children: props.getTime() }));
};
export default Timer;
